<template>

  <div class="auth-wrapper auth-v2">
    
    <b-row class="auth-inner m-0">
      
      <div v-if="loading" class="text-center" style="width: 100%;height: 100vh;position:absolute; z-index:1;background-color: #ffffff6b;">
        <div style=" margin-top: 50%;margin-left: 10%; margin-right: 10%;">
          <img src="@/assets/images/ganImage/GanLoading.gif" alt="">
          <h4 >Por favor espere mientras cargamos su perfil</h4>
        </div>
        
      </div>
      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex  auth-bg px-0 p-lg-5"
      >
    
        <b-col
          sm="12"
          md="12"
          lg="12"
          class="px-xl-1 mx-auto"
        >

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
          <div class="d-flex justify-content-center align-items-center mt-2">
            <img src="@/assets/images/logo/logoNew.png" width="200" class="mb-4" />
          </div>
            <h2 class="brand-text  mt-4 d-flex justify-content-center align-items-center">
                Bienvenido a GANAPP
            </h2>
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userName"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                  <b-link :to="{name:'auth-forgot-password'}" :disabled="!online">
                    <small style="color:#5E8F23" >¿Olvidó la contraseña?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Recuérdame
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                class="bg-primary loginBtn"   
                block
              >
                Ingresar
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
          
            <b-link :to="{name:'auth-register'}" :disabled="!online">
              <span class="registerLink">&nbsp;Regístrate</span>
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
    <!-- /Login-->
    
    </b-row>
    <div class="lgnfooter w-full text-center items-center"> 
        <v-offline 
        online-class="online"
        offline-class="offline"
        @detected-condition="onConnectionChange">
            <template v-if="online">
              <div class="flex w-full h-full justify-center items-center text-6xl">
                  
              </div>
            </template>
            <template v-if="!online">
              <div class="text-center items-center">
                <b-img width="100px" 
                src="@/assets/images/ganImage/icons/offline_white.png"
                />
                <p><strong>Sin Conexión</strong></p>
              </div>
            </template>
        </v-offline>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import axios from 'axios'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { VOffline } from 'v-offline';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    VOffline,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      online:true,
      loading:false,
      status: '',
      password: '',
      userName: '',
      // validation rules
      required,
      email,
      currentUser:'',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    login() {
      let self= this;
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          if(this.online){
            this.loading=true;
            axios.post(this.$apiUrl+'login',{
              username : this.userName,
              password: this.password,
            })
            .then(response => {
                let userData = response.data
                console.log("starting_point")
                useJwt.setToken(response.data.JWT)
                console.log(response.data);
                // axios.defaults.headers.common['X-Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
                useJwt.setRefreshToken(response.data.JWT)
                localStorage.setItem('userData', JSON.stringify(userData.JWT))
                //localStorage.setItem('userData', userData.JWT)
                console.log(localStorage.getItem("accessToken"))
                this.$ability.update([{action: 'manage', subject: 'all'}])
                const token =userData.JWT;
                const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                fetch(this.$apiUrl+"list/users?recperpage=all", config)
                .then(response => response.json())
                .then(result => {
                  console.log(result.users);
                  result.users.forEach(UserRow => {
                    if(UserRow.email==this.userName){
                      localStorage.setItem('userMeta', JSON.stringify(UserRow));
                      localStorage.setItem('userID', UserRow.id)
                      localStorage.setItem("currentLevelAccess", "Administrador");
                      this.loading=false;
                      this.$router.replace('/')
                      .then(() => {
                        let userMeta= JSON.parse(localStorage.getItem('userMeta'));
                        console.log(userMeta)
                        let welcome= 'Bienvenido '+ userMeta.names+', te estábamos esperando.';
                        this.$toast({
                          component: ToastificationContent,
                          position: 'top-center',
                          props: {
                            title: welcome,
                            icon: 'StarIcon',
                            variant: 'success',
                          },
                        })
                      })
                    }else{
                      this.$router.replace('/');
                    }
                  });
                })
            })
            .catch(error => {
              //alert('error');
              console.log(error);
              this.loading=false;
              this.$swal({
                title: 'Error',
                text: 'Usuario o contraseña no validos.',
                type: 'error',
                icon:'error',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
              })
              //this.$refs.loginForm.setErrors('Usuario o contraseña no validos')
            })
          }
          else{
            self.$swal({
              title: 'Sin conexión',
              text: 'Requiere acceso a internet para iniciar sesión.',
              type: 'error',
              icon:'error',
              showCancelButton: false,
              confirmButtonColor:'#5E8F23',
              showCloseButton: true,
              showLoaderOnConfirm: false  
            });
          }
          
        }
      })
    },
    onConnectionChange(status) {
      this.online=status;
      console.log(status);
    },
    created(){
      this.online=navigator.onLine;
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.lgnfooter{
  bottom:0px;
  position:fixed;
  text-align: center;
  display:block;
  justify-content:center;
  margin-left:35%;
}
</style>
